import * as React from 'react';
import { Box, InputBase, IconButton } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { context } from '../context';

export const SearchText = () => {

    const { onSearch, searchType } = React.useContext(context);
    const [inputText, setInputText] = React.useState('');
    const [isFocused, setIsFocused] = React.useState(false);

    // 根据搜索类型显示不同的占位符
    const placeholder = searchType === 'summary' 
        ? '搜索直播内容、话题、关键词...' 
        : '搜索字幕内容...';

    const onChange = (e) => {
        setInputText(e.target.value || '');
    }

    const onClick = (e) => {
        onSearch(inputText);
    }
    
    const onKeyPress = (e) => {
        if (e.charCode === 13) {
            onClick(e);
        }
    }

    return (
        <Box 
            sx={{ 
                display: 'flex', 
                alignItems: 'center', 
                width: '100%',
                border: '1px solid',
                borderColor: isFocused ? 'primary.main' : 'rgba(0, 0, 0, 0.1)',
                borderRadius: '10px',
                bgcolor: 'background.paper',
                transition: 'all 0.2s ease-in-out',
                '&:hover': {
                    borderColor: isFocused ? 'primary.main' : 'primary.light',
                },
            }}
        >
            <InputBase 
                sx={{ 
                    ml: 2, 
                    flex: 1,
                    py: 1,
                    fontSize: '0.9375rem',
                    '& input::placeholder': {
                        color: 'text.disabled',
                        opacity: 1,
                    },
                }} 
                placeholder={placeholder}
                inputProps={{ 'aria-label': placeholder }}
                onChange={onChange} 
                onKeyPress={onKeyPress}
                onFocus={() => setIsFocused(true)}
                onBlur={() => setIsFocused(false)}
            />
            <IconButton 
                type="submit" 
                aria-label="搜索" 
                onClick={onClick}
                sx={{ 
                    p: 1.25,
                    mr: 0.5,
                    color: isFocused ? 'primary.main' : 'text.secondary',
                    '&:hover': {
                        bgcolor: 'rgba(255, 139, 147, 0.08)',
                        color: 'primary.main',
                    },
                }}
            >
                <SearchIcon sx={{ fontSize: '1.25rem' }} />
            </IconButton>
        </Box>
    )
}